import { defineMessages } from 'react-intl';

export default defineMessages({
    header: {
        id: 'app.containers.LinkedCourseModal.header',
        defaultMessage: 'Choose a curriculum/master course from the drop down below to be linked to the course'
    },
    button: {
        id: 'app.containers.LinkedCourseModal.button',
        defaultMessage: 'Ok'
    },
    cancel: {
        id: 'app.containers.LinkedCourseModal.cancel',
        defaultMessage: 'Cancel'
    }
});



// WEBPACK FOOTER //
// ./app/components/linked-course-modal/messages.js